import { useCallback, useEffect } from 'react';

export interface ILocalStorageSignup {
  provinceNameArr?: string[];
  districtNameArr?: string[];
  vehicleTypeArr?: string[];
  businessTypeArr?: string[];

  provinceName?: string;
  vehicleType?: string;

  firstname: string;
  lastname: string;
  citizenId: string;
  phone: string;
  referrerCode: string;
  isAcceptedTerm: boolean;
  byPassLogin: boolean;
  otpRefCode: string;
  otpDigit: number;
  vendorName: string;
  expired: string;
}

type IGetValueSignupKey = keyof ILocalStorageSignup;

const initialState = {
  provinceName: '',
  vehicleType: '',
  firstname: '',
  lastname: '',
  citizenId: '',
  phone: '',
  referrerCode: '',
  isAcceptedTerm: true,
  byPassLogin: true,
  otpRefCode: '',
  otpDigit: 6,
  vendorName: '',
  expired: '',
};

const signupKey = 'signup';

function getLocalStorageSignup() {
  const localStorageSignup = localStorage.getItem(signupKey);
  if (!localStorageSignup) return null;
  return JSON.parse(localStorageSignup) as ILocalStorageSignup;
}

function setLocalStorageSignup(signup: ILocalStorageSignup) {
  const prvLocalStorageSignup = getLocalStorageSignup();
  if (prvLocalStorageSignup) {
    const nextLocalStorageSignup = { ...prvLocalStorageSignup, ...signup };
    localStorage.setItem(signupKey, JSON.stringify(nextLocalStorageSignup));
  } else {
    localStorage.setItem(signupKey, JSON.stringify(signup));
  }
  return getLocalStorageSignup();
}

function clearLocalStorageSignup() {
  localStorage.removeItem(signupKey);
}

export function useLocalStorageSignup() {
  useEffect(() => {
    const localStorageSignup = getLocalStorageSignup();
    if (!localStorageSignup) {
      setLocalStorageSignup(initialState);
    }
  }, []);

  const setValues = useCallback((signup: ILocalStorageSignup) => {
    const _signup = setLocalStorageSignup(signup);
    return _signup;
  }, []);

  const getValue = useCallback(<K extends IGetValueSignupKey>(key: K) => {
    const signup = getLocalStorageSignup();
    if (signup) {
      return signup[key] as ILocalStorageSignup[K];
    }
    return null;
  }, []);

  const getValues = useCallback(() => {
    const signup = getLocalStorageSignup();
    return signup;
  }, []);

  const clearValues = useCallback(() => {
    clearLocalStorageSignup();
  }, []);

  return {
    getValues,
    getValue,
    setValues,
    clearValues,
  };
}
